export { default } from './focusOnInputOfType'
